import { WdSearchResults } from "./api-types/get-search.js";
import { isWdErrorResponse } from "./api-types/error.js";
import { WdClassPropertyEndpoints, } from "./api-types/get-class-property-endpoints.js";
import { WdClassWithSurroundingsDesc } from "./api-types/get-class.js";
import { WdPropertyWithSurroundingDesc } from "./api-types/get-property.js";
import { WdClassHierarchy } from "./api-types/get-class-hierarchy.js";
import { WdClassSurroundings } from "./api-types/get-class-surroundings.js";
import { WdFilterByInstance } from "./api-types/get-filter-by-instance.js";
import { WdPostSearchResults } from "./api-types/post-experimental-search.js";
export class WdOntologyConnector {
    httpFetch;
    BASE_URL;
    addBaseUrlPrefix = (urlPath) => this.BASE_URL + urlPath;
    API_ENDPOINTS = {
        getSearchUrl: (query) => this.addBaseUrlPrefix(`/search?query=${encodeURI(query)}&searchClasses=true`),
        getClassUrl: (classId) => this.addBaseUrlPrefix(`/classes/${classId}`),
        getPropertyUrl: (propertyId) => this.addBaseUrlPrefix(`/properties/${propertyId}`),
        getHierarchyUrl: (classId, part) => this.addBaseUrlPrefix(`/classes/${classId}/hierarchy?part=${part}`),
        getSurroundingsUrl: (classId) => this.addBaseUrlPrefix(`/classes/${classId}/surroundings`),
        getFilterByInstanceUrl: (instanceUrl) => this.addBaseUrlPrefix(`/filter-by-instance?url=${encodeURI(instanceUrl)}`),
        getClassPropertyEndpointsUrl: (classId, propertyId, domainsOrRanges, order) => this.addBaseUrlPrefix(`/classes/${classId}/properties/${propertyId}/${domainsOrRanges}?order=${order}`),
        postClassSearch: () => this.addBaseUrlPrefix("/search-classes"),
        postPropertySearch: () => this.addBaseUrlPrefix("/search-properties"),
    };
    constructor(httpFetch, baseUrl) {
        this.httpFetch = httpFetch;
        this.BASE_URL = baseUrl;
    }
    async callGetFetch(url, RetCreator) {
        const response = (await (await this.httpFetch(url)).json());
        if (isWdErrorResponse(response)) {
            return response;
        }
        else
            return new RetCreator(response);
    }
    async callPostFetch(data, url, RetCreator) {
        const response = (await (await this.httpFetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })).json());
        if (isWdErrorResponse(response)) {
            return response;
        }
        else
            return new RetCreator(response);
    }
    async getSearch(query) {
        const url = this.API_ENDPOINTS.getSearchUrl(query);
        return await this.callGetFetch(url, WdSearchResults);
    }
    async getClass(classId) {
        const url = this.API_ENDPOINTS.getClassUrl(classId);
        return await this.callGetFetch(url, WdClassWithSurroundingsDesc);
    }
    async getProperty(propertyId) {
        const url = this.API_ENDPOINTS.getPropertyUrl(propertyId);
        return await this.callGetFetch(url, WdPropertyWithSurroundingDesc);
    }
    async getClassHierarchy(classId, part) {
        const url = this.API_ENDPOINTS.getHierarchyUrl(classId, part);
        return await this.callGetFetch(url, WdClassHierarchy);
    }
    async getClassSurroundings(classId) {
        const url = this.API_ENDPOINTS.getSurroundingsUrl(classId);
        return await this.callGetFetch(url, WdClassSurroundings);
    }
    async getFilterByInstance(instanceUri) {
        const clearedInstanceUri = instanceUri.split(/[?#]/)[0];
        const url = this.API_ENDPOINTS.getFilterByInstanceUrl(clearedInstanceUri);
        return await this.callGetFetch(url, WdFilterByInstance);
    }
    async postSearchClasses(config) {
        const url = this.API_ENDPOINTS.postClassSearch();
        return await this.callPostFetch(config, url, (WdPostSearchResults));
    }
    async postSearchProperties(config) {
        const url = this.API_ENDPOINTS.postPropertySearch();
        return await this.callPostFetch(config, url, (WdPostSearchResults));
    }
    async getClassPropertyEndpoints(classId, propertyId, domainsOrRanges, order) {
        const url = this.API_ENDPOINTS.getClassPropertyEndpointsUrl(classId, propertyId, domainsOrRanges, order);
        return await this.callGetFetch(url, WdClassPropertyEndpoints);
    }
}
//# sourceMappingURL=wd-ontology-connector.js.map